import { render, staticRenderFns } from "./officebudgettransactions.vue?vue&type=template&id=935a59da&"
import script from "./officebudgettransactions.vue?vue&type=script&lang=js&"
export * from "./officebudgettransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports